import style from './index.scss'
import { Component } from 'preact';
import SubHeader from '../layout/subheader/';
import Related from '../related/';

class CardMatch extends Component {
  constructor(props) {
      super(props)
      this.state = {
        difficulty:null,
        _cards:null,
        cards: null,
        remaining: null,
        duplicateCards: [],
        randomCards: [],
        matchedCards: [],
        flippedCards: [],
        related:[]
      }
    }
    componentWillMount(props){
      if(typeof window !== 'undefined'){
        window.scrollTo(0, 0)
      }
        if(this.props.matches && this.props.matches['activity-id']){
          this.setState({loading:true});
          fetch('/assets/cards/' + this.props.matches['activity-id'] + '.json')
          .then(function(response) {
            return response.json();
          })
          .then((cardsJSON) =>{
            console.log('setting bundle');
            this.setState({
                _cards:cardsJSON.cards,
                remaining:cardsJSON.cards.length,
                toptext:cardsJSON.toptext,
                bottomtext:cardsJSON.bottomtext,
                heading:cardsJSON.heading,
                related:cardsJSON.related
            });
          }).catch((error)=>{
            this.setState({error:"Bad Bundle"});
          })
        } else {
            this.setState({error:"No Bundle"})
        }
    }
    componentDidMount(){
    }
    handleClick(name,index){
      if(this.state.flippedCards.length == 2){
        setTimeout(() => {
          this.check()
        },750)
      }else {
        let framework = {
          name,
          index
        }
        let matchedCards = this.state.matchedCards
        let cards = this.state.flippedCards
        matchedCards[index].close = false
        cards.push(framework)
        this.setState({
          flippedCards: cards,
          matchedCards: matchedCards
        })
        if(this.state.flippedCards.length == 2){
          setTimeout(() => {
            this.check()
          },750)
        }
      }
    }
    check(){
      let matchedCards = this.state.matchedCards
        if(this.state.flippedCards[0] && this.state.flippedCards[1]) {
            if ((this.state.flippedCards[0].name == this.state.flippedCards[1].name) && (this.state.flippedCards[0].index != this.state.flippedCards[1].index)) {
                matchedCards[this.state.flippedCards[0].index].complete = true
                matchedCards[this.state.flippedCards[1].index].complete = true
            } else {
                matchedCards[this.state.flippedCards[0].index].close = true
                matchedCards[this.state.flippedCards[1].index].close = true
            }
            this.setState({
                matchedCards,
                flippedCards: [],
                remaining: matchedCards.filter(c => !c.complete).length
            })
        }
    }
    start(){
      if(!this.state.cards){
          console.log('no cards');
          return false;
      }
      let matchedCards = [];
      this.state.duplicateCards = this.state.cards.concat(this.state.cards)
      this.state.randomCards = this.shuffle(this.state.duplicateCards)
      this.state.randomCards.map((name,index) => {
        matchedCards.push({
          name,
          close: true,
          complete: false,
          fail: false
        })
      })
      this.state.matchedCards = matchedCards
    }
    shuffle(array){
      let currentIndex = array.length, temporaryValue, randomIndex;
      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array
    }
    setDifficulty(cardsNum){
      if(cardsNum){
          this.setState({
              'cards':this.state._cards.slice(0,cardsNum),
              'difficulty':cardsNum
          });
          this.start();
      } else {
          this.setState({
              'cards':null,
              'difficulty':0,
              'remaining':true,
              'matchedCards':[]
          });
      }

    }
    winningText(){
        if(this.state.cards && !this.state.remaining){
            return (<h1>You Win!</h1>);
        }
    }
    render(){
      if(!this.state.cards && !this.state.remaining){
          return <h1>Loading</h1>
      }


        const {toptext, bottomtext, difficulty, heading, subheading, related} = this.state || {};

      if(!difficulty){
          return (
              <div>
              <div className="cards-game">
                <SubHeader heading={heading} subheading={subheading} />
                <p dangerouslySetInnerHTML={{__html:toptext}}/>
                <h2>Select Difficulty</h2>
                <button className="button yellow"onClick={()=>{this.setDifficulty(4)}}>Easy</button>
                <button className="button orange" onClick={()=>{this.setDifficulty(6)}}>Medium</button>
                <button className="button pink" onClick={()=>{this.setDifficulty(10)}}>Hard</button>
                <button className="button purple" onClick={()=>{this.setDifficulty(14)}}>Very Hard</button>
          </div>
                  <Related related={related}/>
              </div>
        );
      }

      return (
          <div className="cards-game">
          <SubHeader heading={heading} subheading={subheading} />
          <p dangerouslySetInnerHTML={{__html:toptext}}/>
          {this.winningText()}
        <button className="button green"onClick={()=>{this.setDifficulty(0)}}>Reset</button>
        <div className={`playground cards-${this.state.cards.length*2}`}>
            {
              this.state.matchedCards.map((framework, index) => {
                return <Card framework={framework.name} click={() => {this.handleClick(framework.name,index)}} close={framework.close} complete={framework.complete}/>
              })
            }
        </div>
        <p dangerouslySetInnerHTML={{__html:bottomtext}}/>
        <Related related={related}/>
        </div>
      )
    }
}

class Card extends Component {
  constructor(props) {
      super(props)
      this.state = {

      }
    }
  clicked(framework){
    this.props.click(framework)
  }
  render(){
    return (
      <div className={"card" + (!this.props.close ? ' opened' : '') + (this.props.complete ? ' matched' : '')} onClick={() => this.clicked(this.props.framework)}>
        <div className="front"></div>
        <div className="back" style={{backgroundImage:`url(/assets/cards/${this.props.framework}.png)`}}>
        </div>
      </div>
    )
  }
}

export default CardMatch;



// WEBPACK FOOTER //
// ./components/cards/index.js